import React, { useState } from "react";
import "./AllTransaction.css";
import TransactionDetails from "../../main/TransactionDetails";
import uppink from "../../../assets/Uppink.svg";
import upgreen from "../../../assets/upgreen.svg";
import downred from "../../../assets/downred.svg";
import backicon from "../../../../../Assets/backicon.svg";
import { AllTransactionIndex } from "../transaction-modal/transactionIndex";
import { Util } from "../../../../../../helpers/util";

const AllTransaction = ({ transactions }) => {
  const [Transac, setTransac] = useState(0);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const { currency } = Util.getCurrency();
  return (
    <>
      <div className="deposit-main">
        {transactions.map((item) => {
          const { isNeutral } = item;
          const isPositiveNumber = item.amount > 0;
          const icon =
            (isNeutral && uppink) || (isPositiveNumber ? upgreen : downred);
          const sign = (isNeutral && " ") || (isPositiveNumber ? "+" : "-");
          const color =
            (isNeutral && "default") ||
            (isPositiveNumber ? "#038830" : "#ee5253");

          return (
            <>
              <a
                href="#allTransactionModal"
                onClick={() => {
                  console.log(item);
                  setSelectedTransaction(item);
                }}
                style={{
                  cursor: "pointer",
                }}
              >
                <TransactionDetails
                  icon={icon}
                  title={item.description}
                  date={item.dateResolved.format("MMMM DD, YYYY")}
                  amount={`${sign} ${currency}${Math.abs(
                    item.amount
                  ).toLocaleString()}`}
                  status={item.status}
                  style={{ color }}
                  key={item.id}
                />
              </a>
              <div className="hr"></div>
            </>
          );
        })}
      </div>

      <>
        <div id="allTransactionModal" className="allTransactionModal">
          <div className="alltransaction-head">
            {Transac === 0 ? (
              <a
                href="#dummy"
                className="closemodalicon-btn"
                onClick={() => {
                  setTransac(0);
                }}
              >
                <img src={backicon} alt="" className="closemodal" />
              </a>
            ) : null}

            <AllTransactionIndex
              {...{ Transac, setTransac, selectedTransaction }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default AllTransaction;
